import { ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';

import { CookieService } from 'ngx-cookie';

import { IMegaFooter } from './mega.footer.interface';
import { ICitiesCollection, ISportsCollection } from '../../../molecules/footer.nav/footer.nav.interface';

@Component({
    selector: 'mlp-ng-mega-footer',
    templateUrl: './mega.footer.component.html',
    styleUrls: ['./mega.footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class MegaFooterSharedComponent implements OnChanges {
    @Input() data: IMegaFooter;
    @Input() city: string;
    @Input() cities: ICitiesCollection;
    @Input() sports: ISportsCollection;
    @Input() cityUppercase: string;
    currentYear = new Date().getFullYear();

    constructor(
        private cookieService: CookieService
    ) {}

    ngOnChanges(): void {
        if (this.city) {
            const cityHolder = this.city;
            if (!this.cityUppercase) {
                this.cityUppercase = cityHolder.charAt(0).toUpperCase() + cityHolder.substr(1);
            }
        }
    }

    clearCityCookie(url: string): void {
        if (url === '/') {
            this.cookieService.remove('city');
            window.location.href = '/';
        }
    }
}
